var OCS = OCS || {};
OCS.User = OCS.User || {};
OCS.Classes = OCS.Classes || {};

OCS.Classes.OkfirstUser = new Class({
    Extends: OCS.Classes.User,
    options: {
        myproducts: [],
        panel_configs: [],
        
        user_preferences: {
            'home_county': 'okz029',
            'home_stid': 'nrmn',
            'map_bgcolor': 'white',
            'anim_speed': 250,
            'only_static_maps': 0,
            'radar': 'KTLX',
            'wind_arrows': false,
            'ww_counties': ''
        }
    },
    get_myproducts: function () {
        return this.options.myproducts;
    },
    set_myproducts: function (myproducts) {
        this.options.myproducts = myproducts;
    },
    get_panel_configs: function () {
        return this.options.panel_configs;
    },
    set_panel_configs: function (panel_config) {
        panel_config.each(function (config, key) {
            config.default_configuration = config.default_configuration * 1;
            config.panel_config_id = config.panel_config_id * 1;
            config.sort_order = config.sort_order * 1;
        });
        this.options.panel_configs = panel_config;
    }
});